import { useQuery } from '@tanstack/react-query'
import {
  fetchPowerBiEmbedConfig,
  type PowerBiDashboardType,
} from '@/api/powerbi'
import { queryKeys } from '@/lib/queryKeys'

const POWER_BI_STALE_TIME = 45 * 60 * 1000
const POWER_BI_GC_TIME = 60 * 60 * 1000
const TOKEN_EXPIRY_BUFFER_MS = 5 * 60 * 1000

export function usePowerBiDashboard(
  reportId: string | null,
  reportType: PowerBiDashboardType | null,
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: queryKeys.powerBi.dashboard(
      reportType ?? 'unselected',
      reportId ?? 'unselected'
    ),
    queryFn: () =>
      fetchPowerBiEmbedConfig(
        reportId as string,
        reportType as PowerBiDashboardType
      ),
    enabled: Boolean(reportId && reportType) && (options?.enabled ?? true),
    staleTime: query => {
      const data = query.state.data
      if (!data?.expiry) return POWER_BI_STALE_TIME
      const msRemaining =
        new Date(data.expiry).getTime() - Date.now() - TOKEN_EXPIRY_BUFFER_MS
      return Math.max(0, msRemaining)
    },
    gcTime: POWER_BI_GC_TIME,
    retry: 1,
  })
}
